import { FC } from 'react';
import CancelledStateMessage from './CancelledStateMessage';
import { SelfServiceAPI } from 'types';
import ChangeStateMessage from './ChangeStateMessage';

interface StateMessagingProps {
  booking: SelfServiceAPI.Booking;
}

const StateMessaging: FC<StateMessagingProps> = ({ booking }) => (
  <>
    <CancelledStateMessage booking={booking} />
    <ChangeStateMessage booking={booking} />
  </>
);

export default StateMessaging;
